import { GetServerSideProps } from 'next';
import React from 'react';
import Layout from '../../components/Layout/Layout';
import ResourcesComponent from '../../components/Resources/ResourcesComponent';
import { apiRequest } from '../../components/util/requests/requests';
import { PageMetadata } from '../../components/util/SeoMetaInformationComponent/SeoMetaInformationComponent';
import { ResourceCategory } from '../../components/Models/ResourceProps';

export interface ResourceProps {
    resourceCategories: ResourceCategory[];
    pageMetadata?: PageMetadata;
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    // const pageMetadata = await apiRequest('/meta-pages?filters[key]=SOLUTIONS_BANKING_PAGE&populate[0]=seo');
    const resourceCategories = await apiRequest('/resource-categories');

    return {
        props: {
            resourceCategories: resourceCategories.data,
            // pageMetadata: pageMetadata.data && pageMetadata.data.length > 0 ? pageMetadata.data[0] : null
        },
    };
};

const Resources = ({ resourceCategories, pageMetadata }: ResourceProps) => {
    return (
        <Layout seoMetadata={pageMetadata?.seo} defaultMetaTitle={'Noria.no - Resources'}>
            <ResourcesComponent resourceCategories={resourceCategories} />
        </Layout>
    );
};

export default Resources;
